<template>
    <!--購物車-->
    <div class="addCart" :key="updateCartKey">
        <div class="con" @click="onClickGoCart">
            <div class="count">{{cartItemAmount}}</div>
            <i class="el-icon-shopping-cart-2"/>
            <span>購物車</span>
        </div>
        <div class="shopping-cart"
             @mouseenter="shoppingDetail"
             @mousemove="holdShoppingDetailOpen"
             @mouseleave="bodyCloseSelected">
            <el-button @click.stop="onClickGoCart"><i class="el-icon-shopping-cart-2"/>購物車<b> {{cartItemAmount}} </b>個商品</el-button>
            <div class="shopping-list" id="shoppingList" :class="{'open':openCart}">
                <table>
                    <tr>
                        <th>商品名稱</th>
                        <th class="fixed-w-100">數量</th>
                    </tr>
                    <tr v-for="(item, index) in cartList" :key="index">
                        <td>{{ item.name }}</td>
                        <td class="fixed-w-100 text-center">
                            {{ item.buyAmount }}
                        </td>
                    </tr>
                </table>
                <div class="text-right">
                    <el-button round type="warning" @click="onClickGoCart">前往結帳</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cart from '@/util/cart';

    export default {
        name: "AddCart",
        props:{
            open: {default: false},//電腦版購物車商品細項
        },
        data() {
            return {
                //開啟購物車
                openCart: this.open,
                //電腦版購物車資訊-假資料可刪
                cartList: [],
                cartItemAmount: 0,       //購物車商品數量
                updateCartKey: 0,
                cartAutoCloseTimer: null,
                documentClickListenerTimer: null,
                hasDocumentClickListener: false,
            }
        },
        beforeUpdate() {
            this.cartList = Cart.getCart();
            this.cartItemAmount = Cart.getItemBuyAmount(this.cartList);       //購物車商品數量
        },
        created() {
        },
        mounted() {
            this.cartList = Cart.getCart();
            this.cartItemAmount = Cart.getItemBuyAmount(this.cartList);       //購物車商品數量
        },
        beforeDestroy() {
            this.clearCartAutoCloseTimer()
            this.removeDocumentClickListener()
        },
        methods: {

            /** 點擊結帳 */
            onClickGoCart: function() {
                let isLogin = this.$auth.isAdminLogin();
                //有登入就直接到購物車，沒有就先跳到登入
                if (isLogin) {
                    this.$router.push({name: 'Cart'});
                } else {
                    this.$public.setPathAfterLogin(`Cart`, "");
                    this.$router.push({name: 'Login'});
                }
            },

            clearCartAutoCloseTimer() {
                window.clearTimeout(this.cartAutoCloseTimer)
                this.cartAutoCloseTimer = null
            },
            removeDocumentClickListener() {
                window.clearTimeout(this.documentClickListenerTimer)
                this.documentClickListenerTimer = null
                if (this.hasDocumentClickListener) {
                    document.removeEventListener('click', this.bodyCloseSelected)
                    this.hasDocumentClickListener = false
                }
            },
            addDocumentClickListener() {
                if (!this.hasDocumentClickListener) {
                    document.addEventListener('click', this.bodyCloseSelected)
                    this.hasDocumentClickListener = true
                }
            },
            openShoppingDetail(duration = 5000) {
                let shoppingCart = this.$el.querySelector('.shopping-cart')
                let shoppingCartRect = shoppingCart?.getBoundingClientRect()
                if (window.innerWidth < 1024 || !shoppingCartRect || shoppingCartRect.width === 0 || shoppingCartRect.height === 0) {
                    return
                }

                this.clearCartAutoCloseTimer()
                this.openCart = true
                this.documentClickListenerTimer = window.setTimeout(() => {
                    this.addDocumentClickListener()
                })
                this.cartAutoCloseTimer = window.setTimeout(() => {
                    this.bodyCloseSelected()
                }, duration)
            },
            //開啟購物車資訊框
            shoppingDetail() {
                this.addDocumentClickListener()
                if (!this.openCart) {
                    this.clearCartAutoCloseTimer()
                }
                this.openCart = true

            },
            holdShoppingDetailOpen() {
                if (this.openCart) {
                    this.clearCartAutoCloseTimer()
                }
            },
            bodyCloseSelected(){
                this.clearCartAutoCloseTimer()
                if(this.openCart){
                    this.openCart= false
                }
                this.removeDocumentClickListener()
            },
        },
        watch:{
            open(){
                this.openCart = this.open;
            },
            //監聽購物車更新key
            '$store.state.shopAreaCartData.updateCartKey': function() {
                this.updateCartKey = this.$store.state.shopAreaCartData.updateCartKey;
            },
            '$store.state.shopAreaCartData.openCartDetailKey': function() {
                this.openShoppingDetail(5000)
            },
        },
    }
</script>
<style scoped lang="less">
    .addCart{
        z-index: 99;
        @media(max-width: 1023px){
            bottom: calc(70px + env(safe-area-inset-bottom));
            right: 10px;
            position: fixed;
        }
        //小螢幕才有
        .con{
            @media(max-width: 1023px){
                position: relative;
                width: 48px;
                line-height: 1em;
                height: 48px;
                border-radius: 50%;
                background: rgba(76,36,29,.9);
                color: #fff;
                text-align: center;
                .count{
                    background: var(--color-red);
                    position: absolute;
                    font-size: 12px;
                    transform: scale(.7);
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    right: -2px;
                    top: -2px;
                }
                i{
                    font-size: 20px;
                    margin: 8px 0 0;
                }
                span{
                    font-size: 12px;
                    transform: scale(.7);
                    display: block;
                    margin-top: -3px;
                }
            }
            @media(min-width: 1024px){
                display: none;
            }
        }
        //寬螢幕才有
        .shopping-cart{
            @media(max-width: 1023px){
                display: none;
            }
            @media(min-width: 1024px){
                padding-bottom: 15px;
                margin: 13px 10px 0 10px;
                width: 160px;
                &>.el-button{
                    font-size: 13px;
                    height: 30px;
                    border: none;
                    padding: 2px 15px;
                    background: var(--color-brown2);
                    border-radius: 16px;
                    color: #fff;
                    float: right;
                    position: relative;
                    z-index: 3;
                    i{
                        font-size: 20px;
                        vertical-align: -10%;
                        margin-right: 5px;
                    }
                    /deep/span{
                        margin: 0;
                    }
                }

            }
        }
        //寬螢幕才有
        .shopping-list{
            @media(max-width: 1023px){
                display: none;
            }
            @media(min-width: 1024px){
                z-index: 1;
                position: fixed;
                top: -140%;
                right: calc( 50% - 490px);
                width: 420px;
                border: 1px solid var(--color-gray);
                background: #fff;
                padding: 10px 20px 15px;
                transition: opacity .4s;
                opacity: 0;
                table{
                    width: 100%;
                    color: var(--color-brown2);
                    th{
                        border-bottom: 1px solid var(--color-gray);
                        text-align: center;
                        padding-bottom: 5px;
                        font-size: 14px;
                    }
                    td{
                        font-size: 13px;
                        padding: 8px 8px 0;

                    }
                }
                .el-button{
                    height: 28px;
                    margin-top: 10px;
                    padding: 0 15px;
                }
            }
            &.open{
                @media(max-width: 1023px){
                    display: none;
                }
                @media(min-width: 1024px) {
                    height: inherit;
                    transition: opacity .4s;
                    top: calc(env(safe-area-inset-top) + 58px);
                    opacity: 1;
                }
            }
        }
    }
    //APP版寬螢幕用
    .isApp{
        .addCart{
            @media(min-width: 1024px){
                position: absolute;
                right: 10px;
                bottom: -30px;
                .shopping-list.open{
                    top: calc(env(safe-area-inset-top) + 108px);
                }
            }
        }
    }
</style>
